import Incentives from './Incentives.svg';
import Statements from './Statements0.svg';
import Forms from './Forms-Docs.svg';
import Leaderboard from './Leaderboard0.svg';
import MSHAcademy from './MSH-Academy.svg';
import TrainingHub from './Training_Hub.svg';
import TravelAdvisories from './Travel_Advisories.svg';
import CurrencyExchange from './Currency_Exchange.svg';
import DocumentFile from './Document-file.svg';
import StatementFile from './Statement-file.svg';
import Rank1 from './Rank-1.svg';
import Rank2 from './Rank-2.svg';
import Rank3 from './Rank-3.svg';
import ForwardArrow from './Forward_arrow.svg';
import SellNow from './Sell-Now.svg';
import Quotes from './Quotes.svg';
import Dashboard from './Dashboard.svg';
import Menu from './Menu.svg';
import Policies from './Policies.svg';
import Settings from './Settings0.svg';
import Language from './Language.svg';
import Preview from './Preview0.svg';
import Download from './Download0.svg';

export default {
    Incentives,
    Statements,
    Forms,
    Leaderboard,
    MSHAcademy,
    TrainingHub,
    TravelAdvisories,
    CurrencyExchange,
    DocumentFile,
    StatementFile,
    Rank1,
    Rank2,
    Rank3,
    ForwardArrow,
    SellNow,
    Quotes,
    Dashboard,
    Menu,
    Policies,
    Settings,
    Language,
    Preview,
    Download
}


// WEBPACK FOOTER //
// ./src/Logos/AgentDashboard/Icons.js